import ChallengeEvaluationList from './ChallengeEvaluationList';

export default ChallengeEvaluationList;
